export default "__VITE_ASSET__$bAZddxG__"